import { JSX, on, Switch } from "solid-js";
import { useTelescopeContext } from "@hubble/telescope";
import { goBack } from "~/shared_states/modal";

export type TncsModalProps = {
  headerText?: string;
  tncs: string[];
};

export function IndiryaTncsModal(props: TncsModalProps): JSX.Element {
  const { components } = useTelescopeContext();

  // Fetch T&C data from API
  //
  return (
    <div class=" flex flex-col">
      {/* Modal Header */}
      <div class="sticky top-0">
        <components.ModalHeader
          size="small"
          title={props.headerText || "Terms & Conditions"}
          onClose={() => {
            goBack();
          }}
        />
      </div>

      {/* Content */}
      <div class="px-5 py-5">
        <div class="text-title-6-regular text-text-normal-primary">
          {props.tncs.map((tnc, index) => (
            <div class="flex flex-row items-start gap-2">
              <div class="text-label-regular text-text-normal-secondary">
                {index + 1}.
              </div>
              <div class="mb-2 text-label-regular text-text-normal-secondary">
                {tnc}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
